import { Component, ChangeDetectorRef, EventEmitter } from '@angular/core';
import { HeaderComponent } from '../../../../layout/header/header.component';
import { NavbarComponent } from '../../../../layout/navbar/navbar.component';
import { SidebarComponent } from '../../../../layout/sidebar/sidebar.component';
import { RoutelinksService } from '../../../../services/core/routelinks.service';
import { FormsModule, ReactiveFormsModule, FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { RateModelDto } from '../../../../models/ratemodeldto';
import { TaxesService } from '../../../../services/taxes.service';
import { VatPatternDto } from '../../../../models/vatPattern/vatpatterndto';
import { TranslateService, TranslatePipe, TranslateDirective, LangChangeEvent } from "@ngx-translate/core";
import { VatPatternService } from '../../../../services/vatpattern.service';
import { PaginatorComponent } from '../../../../components/paginator/paginator.component';
import { ErrorModalComponent } from '../../../../components/error-modal/error-modal.component';
import { OwnAdministrativeFeeDto } from '../../../../models/ownadministrativefeedto';
import { OwnAdministrativeFeeService } from '../../../../services/ownadministrativefee.service';
import { OwnAdministrativeFeeDetailDto } from '../../../../models/ownadministrativefeedetaildto';
import { OwnAdministrativeFeeDetailService } from '../../../../services/ownadministrativefeedetail.service';
import { AdministrativeFeeCatalogDto } from '../../../../models/administrativefeecatalogdto';
import { AdministrativeFeeCatalogService } from '../../../../services/administrativefeecatalog.service';
import { OwnAdministrativeFeeRequest } from '../../../../models/ownAdministrativeFeeRequest';
import { OwnAdministrativeFeeResponse } from '../../../../models/ownAdministrativeFeeResponse';
import { OwnAdministrativeFeeDetailRequest } from '../../../../models/ownAdministrativeFeeDetailRequest';
import { OwnAdministrativeFeeDetailResponse } from '../../../../models/ownAdministrativeFeeDetailResponse';
import { RateModelRequest } from '../../../../models/rateModelRequest';
import { RateModelResponse } from '../../../../models/rateModelResponse';
import { AdministrativeFeeCatalogRequest } from '../../../../models/administrativeFeeCatalogRequest';
import { AdministrativeFeeCatalogResponse } from '../../../../models/administrativeFeeCatalogResponse';
import { VatPatternRequest } from '../../../../models/vatPattern/vatPatternRequest';
import { VatPatternResponse } from '../../../../models/vatPattern/vatPatternResponse';
import { SharedService } from '../../../../services/shared.service';
import { AlertComponentComponent } from '../../../../components/alert/alert-component.component';
import { GeneralDiscountCatalogDto, GeneralDiscountCatalogRequest, GeneralDiscountCatalogResponse } from '../../../../models/discountGeneralCatalog/GeneralDiscountCatalogDto.model';
import { IdOwnRateDiscountDto, IdOwnRateDiscountDtoRequest, IdOwnRateDiscountDtoResponse } from '../../../../models/discountGeneralCatalog/OwnRateDiscount.modelDto';
import { DiscountService } from '../../../../services/discountService.service';
import { DiscountRateModelCatalogResponse } from '../../../../models/discountGeneralCatalog/DiscountRateModelCatalog.model';

@Component({
  selector: 'app-administrativetaxes',
  standalone: true,
  imports: [HeaderComponent, NavbarComponent, SidebarComponent, CommonModule, FormsModule, ReactiveFormsModule, TranslatePipe, TranslateDirective, PaginatorComponent, ErrorModalComponent, AlertComponentComponent],
  templateUrl: './administrativetaxes.component.html',
  styleUrl: './administrativetaxes.component.css'
})
export class AdministrativetaxesComponent {
  links: any[] = [];
  subLinks: any[] = [];

  currentLanguage: string = 'es'; // Idioma actual
  selectedRateModel: RateModelDto = new RateModelDto(); // Modelo de tasa seleccionado
  selectedAdministrativeFeeCatalogDto: AdministrativeFeeCatalogDto = new AdministrativeFeeCatalogDto();
  isModalOpen: boolean = false; // Controla la visibilidad del modal
  message: Array<any> = []; // Mensaje del modal de error

  ownadministrativefee: OwnAdministrativeFeeDto = new OwnAdministrativeFeeDto(); // Objeto para almacenar la tasa administrativa propia

  selectedRowId: any = null; // Variable para almacenar el ID de la fila seleccionada
  isCreate: boolean = false;
  selectedPricesRowId: any = null; // Variable para almacenar el ID de la fila seleccionada
  isCreatePrices: boolean = false;
  isError: boolean = false;
  isCreated: boolean = false;
  isErrorPrice: boolean = false;
  isCreatedPrice: boolean = false;
  isCreateOwnRateDiscount: boolean = false;
  isCreatedOwnRateDiscount: boolean = false;
  isClone: boolean = false; // se ha producido un error

  selectedOwnRateDiscount: IdOwnRateDiscountDto = new IdOwnRateDiscountDto(); // Tasa académica seleccionada
  selectedOwnRateDiscountId: any = null; // Precio académico seleccionado
  isErrorOwnRateDiscount: boolean = false;
  private langChangeSubscription!: Subscription;

  createPrice = true; // Variable para determinar si se crea un nuevo precio de recurso
  modifTranslates: boolean = false; // Variable para determinar si se han modificado las traducciones
  showErrorModal: boolean = false; // Controla la visibilidad del modal de error
  errorTitle: string = ''; // Título del modal de error
  errorMessage: string = ''; // Mensaje del modal de error

  ownAdministrativeFeeRequest: OwnAdministrativeFeeRequest = new OwnAdministrativeFeeRequest(); // Objeto para la solicitud de tasa administrativa propia
  ownAdministrativeFeeResponse: OwnAdministrativeFeeResponse = new OwnAdministrativeFeeResponse(); // Objeto para la respuesta de tasa administrativa propia
  ownAdministrativeFeeDetailRequest: OwnAdministrativeFeeDetailRequest = new OwnAdministrativeFeeDetailRequest(); // Objeto para la solicitud de detalle de tasa administrativa
  ownAdministrativeFeeDetailResponse: OwnAdministrativeFeeDetailResponse = new OwnAdministrativeFeeDetailResponse(); // Objeto para la respuesta de detalle de tasa administrativa
  modelRequest: RateModelRequest = new RateModelRequest(); // Objeto para la solicitud de modelo
  modelResponse: RateModelResponse = new RateModelResponse(); // Objeto para la respuesta de modelo
  administrativeFeeCatalogRequest: AdministrativeFeeCatalogRequest = new AdministrativeFeeCatalogRequest(); // Objeto para la solicitud de catálogo de tasas administrativas
  administrativeFeeCatalogResponse: AdministrativeFeeCatalogResponse = new AdministrativeFeeCatalogResponse(); // Objeto para la respuesta de catálogo de tasas administrativas
  vatPatternRequest: VatPatternRequest = new VatPatternRequest(); // Objeto para la solicitud de patrón de IVA
  vatPatternResponse: VatPatternResponse = new VatPatternResponse(); // Objeto para la respuesta de patrón de IVA
  discountReponse: GeneralDiscountCatalogResponse = new GeneralDiscountCatalogResponse();
  discountRequest: GeneralDiscountCatalogRequest = new GeneralDiscountCatalogRequest();
  ownRateDiscountRequest: IdOwnRateDiscountDtoRequest = new IdOwnRateDiscountDtoRequest();
  ownRateDiscountResponse: IdOwnRateDiscountDtoResponse = new IdOwnRateDiscountDtoResponse();
  discountRateModelResponse: DiscountRateModelCatalogResponse = new DiscountRateModelCatalogResponse();
  listCatalog: AdministrativeFeeCatalogDto[] = [];
  constructor(private routelinks: RoutelinksService, private cdr: ChangeDetectorRef,
    private translateService: TranslateService, private ownadministrativefeeService: OwnAdministrativeFeeService, private taxesService: TaxesService,
    private vatPatternService: VatPatternService, private ownadministrativefeeDetailService: OwnAdministrativeFeeDetailService,
    private catalogService: AdministrativeFeeCatalogService, private sharedService: SharedService, private discountServices: DiscountService) {
    this.links = this.routelinks.linksTaxes; // Inicializa la propiedad en el constructor
    this.subLinks = this.routelinks.subLinksTaxes; // Inicializa la propiedad en el constructor

    this.currentLanguage = this.translateService.currentLang || 'es'; // Establece el idioma actual
  }

  formDiscount = new FormGroup({
    discountCode: new FormControl(),
    importType: new FormControl('I'),
    idOwnRateDiscount: new FormControl(),
    rateType: new FormControl('A', Validators.required),
    discountPercentage: new FormControl(),
    fixedDiscountAmount: new FormControl(),
    discountOrderNumber: new FormControl(0, Validators.required),
    startDate: new FormControl('', Validators.required),
    endDate: new FormControl(''),
    idRateModel: new FormControl(),
    idGeneralDiscountCatalog: new FormControl(),
  });

  ownAdministrativeFeeFormPrice = new FormGroup({
    idOwnAdministrativeFeeDetail: new FormControl(), // ID del detalle de la tasa administrativa
    startDate: new FormControl('', Validators.required), // Fecha de inicio (obligatoria)
    endDate: new FormControl(''), // Fecha de fin (opcional)
    optionalFeeIndicator: new FormControl(false), // Indicador de tasa opcional
    firstPaymentIndicator: new FormControl(false), // Indicador de primer pago
    ageControlIndicator: new FormControl(false), // Indicador de control de edad
    ageLimit: new FormControl(), // Límite de edad (opcional, debe ser >= 0)
    price: new FormControl(0, [Validators.min(0)]), // Precio (obligatorio, debe ser >= 0)
    idVatPattern: new FormControl(), // ID del patrón de IVA (opcional)
  });

  filterParams = new FormGroup({
    taxModel: new FormControl(), // Control para el select "Tipo de tasa"
  });

  ownAdministrativeFeeForm = new FormGroup({
    idOwnAdministrativeFee: new FormControl(), // ID de la tasa administrativa
    active: new FormControl(''), // Estado activo/inactivo
    codeOwnAdministrativeFeeCatalog: new FormControl(''), // ID del catálogo de tasas administrativas
    idRateModel: new FormControl(), // ID del modelo de tasa (para el select)
    idAdministrativeFeesCatalog: new FormControl(), // ID del catálogo de tasas administrativas (para el select)
    descriptionCat: new FormControl('', Validators.required),
    descriptionCast: new FormControl('', Validators.required),
    descriptionIng: new FormControl('', Validators.required)
  });

  ngOnInit(): void {
    this.loadRateModels(false); // Carga los modelos de tasas al inicializar el componente
    this.loadVatPatterns(false);
    this.langChangeSubscription = this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.currentLanguage = event.lang; // Actualizar el idioma actual
      this.loadRateModels(false); // Carga los modelos de tasas al inicializar el componente
      this.loadVatPatterns(false);
      this.cdr.detectChanges();
    });

    this.sharedService.numberPageEventEmitter.subscribe((page: number) => {
      this.ownAdministrativeFeeResponse.pageDto.currentPage = page;
      this.loadOwnAdministrativeFees(false);
    });

    this.filterParams.get('taxModel')?.valueChanges.subscribe((value) => {
      this.selectedRateModel = this.modelResponse.listRateModelDto.find((item) => item.idRateModel === Number(value)) || new RateModelDto(); // Asegura que el valor sea numérico y crea una nueva instancia correctamente
      this.loadOwnAdministrativeFees(true); // Llama a la función para obtener las tasas académicas
      this.selectedRowId = null;
      this.isCreate = false
    });

    this.formDiscount.get('importType')?.valueChanges.subscribe((value) => {
      value == 'I' ? this.formDiscount.get('discountPercentage')?.patchValue(0) : null
      value == 'P' ? this.formDiscount.get('fixedDiscountAmount')?.patchValue(0) : null
    });

  }

  ngOnDestroy(): void {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe(); // Desuscribirse del evento de cambio de idioma
    }
  }

  changeDescompte() {
    if (this.selectedOwnRateDiscountId == null) {
      this.formDiscount.get('fixedDiscountAmount')?.patchValue(0)
      this.formDiscount.get('discountPercentage')?.patchValue(0)
      let discount: GeneralDiscountCatalogDto[] = this.discountReponse.GeneralDiscountCatalogDto.filter(disc => { return disc.idGeneralDiscountCatalog == this.formDiscount.get('idGeneralDiscountCatalog')?.value })
      if (discount[0].discountFixedAmount && discount[0].discountFixedAmount > 0) {
        this.formDiscount.get('fixedDiscountAmount')?.patchValue(discount[0].discountFixedAmount)
        this.formDiscount.get('importType')?.patchValue("I")
      }
      if (discount[0].discountPercentage && discount[0].discountPercentage > 0) {
        this.formDiscount.get('discountPercentage')?.patchValue(discount[0].discountPercentage)
        this.formDiscount.get('importType')?.patchValue("P")
      }
    }
  }

  loadOwnAdministrativeFees(init: boolean): void {
    if (!init) {
      this.ownAdministrativeFeeDetailRequest.pageRequest.page = this.ownAdministrativeFeeDetailResponse.pageDto.currentPage;
    }

    this.ownadministrativefeeService.getListOwnAdministrativeFee(this.ownAdministrativeFeeDetailRequest.pageRequest, this.selectedRateModel.codeRateModel)
      .subscribe({
        next: response => {
          if (response != null) {
            // Asigna la lista de modelos a la propiedad listModels para mostrarlos en la tabla
            this.ownAdministrativeFeeResponse.listOwnAdministrativeFeeDto = response.listOwnAdministrativeFee;
            if (!response.pageDto) {
              this.ownAdministrativeFeeDetailResponse.pageDto = response.pageDto;
            }
            this.loadListAdministrativeFeeCatalog()
          }
        }, error: error => {
          console.log('Se ha producido un error', error);
          this.ownAdministrativeFeeResponse.listOwnAdministrativeFeeDto = []; // Asigna una lista vacía en caso de error
        }
      });
  }

  loadRateModels(init: boolean): void {
    if (!init) {
      this.modelRequest.pageRequest.page = this.modelResponse.pageDto.currentPage;
    }
        this.modelRequest.pageRequest.sizePage = 1000; // Carga un número grande de modelos de tasa para evitar la paginación en el select

    this.taxesService.getListTaxesAll(this.modelRequest.pageRequest).subscribe({
      next: response => {
        if (response != null) {
          // Asigna la lista de modelos a la propiedad listModels para mostrarlos en la tabla
          this.modelResponse.listRateModelDto = response.listRateModel.map((rt: any) => {
            return {
              ...rt,
              rateModelTraductionDto: rt.rateModelTraductionDto.filter((t: any) => t.languageDto.code.includes(this.currentLanguage)),
            };
          });
          this.modelResponse.listRateModelDto = this.modelResponse.listRateModelDto.filter(list => { return list.administrativeFees == true })

          if (response.pageDto !== undefined) {
            this.modelResponse.pageDto = response.pageDto;
          }
        }
      }, error: error => {
        console.log('Se ha producido un error', error);
        this.modelResponse.listRateModelDto = []; // Asigna una lista vacía en caso de error
      }
    });
  }

  loadVatPatterns(init: boolean): void {
    if (!init) {
      this.vatPatternRequest.pageRequest.page = this.vatPatternResponse.pageDto.currentPage;
    }

    this.vatPatternService.getListVatPattern(this.vatPatternRequest.pageRequest).subscribe({
      next: response => {
        if (response != null) {
          this.vatPatternResponse.listVatPatternDto = response.listVatPattern.map((rt: any) => {
            return {
              ...rt,
              vatPatternTraductionDto: rt.vatPatternTraductionDto.filter((t: any) => t.languageDto.code.includes(this.currentLanguage)),
            };
          });
          if (response.pageDto !== undefined) {
            this.vatPatternResponse.pageDto = response.pageDto;
          }
        }
      },
      error: (err) => {
        console.error('Error al obtener los patrones de IVA:', err);
      }
    });
  }

  loadListAdministrativeFeeCatalog() {
    this.catalogService.getAllCatalogs(this.administrativeFeeCatalogRequest.pageRequest).subscribe({
      next: response => {
        if (response != null) {
          // Asigna la lista de modelos a la propiedad listModels para mostrarlos en la tabla
          this.administrativeFeeCatalogResponse.listAdministrativeFeeCatalogDto = response.listAdministrativeFeeCatalog.map((rt: any) => {
            return {
              ...rt,
              administrativeFeeCatalogTraductionDto: rt.administrativeFeeCatalogTraductionDto.filter((t: any) => t.languageDto.code.includes(this.currentLanguage)),
            };
          });
          if (response.pageDto !== undefined) {
            this.administrativeFeeCatalogResponse.pageDto = response.pageDto;
          }
        }
        this.administrativeFeeCatalogResponse.listAdministrativeFeeCatalogDto = this.administrativeFeeCatalogResponse.listAdministrativeFeeCatalogDto.filter(adm => { return adm.typology == this.selectedRateModel.typology })
        this.getListCatalog(this.administrativeFeeCatalogResponse.listAdministrativeFeeCatalogDto)


      }, error: error => {
        this.administrativeFeeCatalogResponse.listAdministrativeFeeCatalogDto = []; // Asigna una lista vacía en caso de error
      }
    });
  }

  getListCatalog(listAdministrativeFeeCatalogDto: AdministrativeFeeCatalogDto[]): Array<AdministrativeFeeCatalogDto> {
    this.listCatalog = []
    listAdministrativeFeeCatalogDto.forEach(list => {
      if (this.ownAdministrativeFeeResponse.listOwnAdministrativeFeeDto.filter(admin => { return admin.administrativeFeeCatalogDto?.idAdministrativeFeesCatalog === list.idAdministrativeFeesCatalog }).length == 0) {
        this.listCatalog.push(list)
      }
    })
    console.log(this.listCatalog)
    return this.listCatalog
  }

  get hasOwnAdministrativeFee(): boolean {
    return this.ownAdministrativeFeeResponse.listOwnAdministrativeFeeDto && this.ownAdministrativeFeeResponse.listOwnAdministrativeFeeDto.length > 0;
  }

  get hasRateModelSelected(): boolean {
    return this.selectedRateModel.codeRateModel != undefined;
  }

  newModel(): void {
    this.ownAdministrativeFeeForm.reset(); // Reinicia el formulario
    this.ownAdministrativeFeeForm.enable()
    this.isCreate = true; // Cambia a modo de creación
    this.isCreateOwnRateDiscount = this.isCreatedOwnRateDiscount = false
    this.selectedRowId = this.selectedPricesRowId = this.selectedOwnRateDiscountId = null; // Deselecciona la fila actual
    this.ownadministrativefee = new OwnAdministrativeFeeDto(); // Reinicia el objeto de tasa administrativa propia
    this.cdr.detectChanges();
    window.scrollTo(0, 600); // Desplaza la vista al inicio de la página
  }

  newAcademicDiscount() {
    this.formDiscount.reset()
    this.formDiscount.enable()
    this.selectedOwnRateDiscountId = null;
    this.isCreatedOwnRateDiscount = true;
    this.formDiscount.get('idRateModel')?.disable()
    this.formDiscount.get('idRateModel')?.patchValue(this.selectedRateModel.codeRateModel)
  }

  onCancel(): void {
    this.isCreate = false; // Cambia a modo de edición
    this.isCreateOwnRateDiscount = this.isCreatedOwnRateDiscount = false
    this.selectedRowId = this.selectedPricesRowId = this.selectedOwnRateDiscountId = null; // Deselecciona la fila actual
    this.ownAdministrativeFeeForm.reset(); // Reinicia el formulario
    window.scrollTo(0, 600); // Desplaza la vista al inicio de la página
  }

  // Seleccionar o deseleccionar una fila en una tabla específica
  toggleRow(row: any): void {
    if (this.selectedRowId === row.idOwnAdministrativeFee) {
      window.scrollTo(0, 0); // Desplaza la vista al inicio de la página
      setTimeout(() => {
        this.selectedRowId = null; // Deselecciona si ya estaba seleccionada
        this.selectedOwnRateDiscountId = null
        this.selectedPricesRowId = null
      }, 350);
    } else {
      this.isCreate = false; // Cambia a modo de edicion
      this.selectedRowId = row.idOwnAdministrativeFee; // Selecciona la nueva fila
      this.getListOwnAdministrativeFeeById();
      this.loadOwnAdministrativeFeePricesById(true);
      this.loadOwnRateDiscountByRateType(row.idOwnAdministrativeFee)
      this.loadDiscounts()
      this.loadDiscountsRateModel()
      if (this.ownAdministrativeFeeResponse.listOwnAdministrativeFeeDto.filter(admin => { return admin.administrativeFeeCatalogDto?.idAdministrativeFeesCatalog === row.administrativeFeeCatalogDto?.idAdministrativeFeesCatalog }).length > 0) {
        this.listCatalog.push(row?.administrativeFeeCatalogDto);
      }
      this.ownAdministrativeFeeForm.disable()
      this.cdr.detectChanges();
      window.scrollTo(0, 600);
    }
    console.log('ID de la fila seleccionada:', this.selectedRowId);
  }

  // Seleccionar o deseleccionar una fila en una tabla específica
  toggleRowPrices(row: any): void {
    if (this.selectedPricesRowId === row.idOwnAdministrativeFeeDetail) {
      setTimeout(() => {
        this.selectedPricesRowId = null; // Deselecciona si ya estaba seleccionada
      }, 350);
    } else {
      if (row) {
        // Si se pasa una fila, llena el formulario con los datos del precio seleccionado
        console.log(row)
        this.ownAdministrativeFeeFormPrice.patchValue({
          idOwnAdministrativeFeeDetail: row.idOwnAdministrativeFeeDetail || null,
          startDate: row.startDate || '',
          endDate: row.endDate || '',
          optionalFeeIndicator: row.optionalFeeIndicator == 'S' ? true : false,
          firstPaymentIndicator: row.firstPaymentIndicator || false,
          ageControlIndicator: row.ageControlIndicator == 'S' ? true : false,
          ageLimit: row.ageLimit || null,
          price: row.price?.toString() || '',
          idVatPattern: row.vatPatternDto?.idVatPattern || null,
        });
        console.log(this.ownAdministrativeFeeFormPrice.value)
        this.selectedPricesRowId = row.idOwnAdministrativeFeeDetail; // Asigna el ID del detalle de la tasa administrativa
      }
      this.isCreatePrices = false; // Cambia a modo de edicion
      this.selectedPricesRowId = row.idOwnAdministrativeFeeDetail; // Selecciona la nueva fila
      this.getListOwnAdministrativeFeeById();
      this.loadOwnAdministrativeFeePricesById(true);
      this.cdr.detectChanges();
    }
    console.log('ID de la fila seleccionada:', this.selectedRowId);
  }

  toggleRowAcademicDiscount(row: any): void {
    if (this.selectedOwnRateDiscountId === row.idOwnRateDiscount) {
      setTimeout(() => {
        this.selectedOwnRateDiscountId = null; // Deselecciona si ya estaba seleccionada
      }, 350);
    } else {
      if (row) {
        this.formDiscount.patchValue({
          startDate: row.startDate,
          endDate: row.endDate,
          rateType: row.rateType,
          idOwnRateDiscount: row.idOwnRateDiscount,
          discountOrderNumber: row.discountOrderNumber,
          fixedDiscountAmount: row.fixedDiscountAmount,
          discountPercentage: row.discountPercentage,
          idRateModel: row.rateModelDto.codeRateModel,
          idGeneralDiscountCatalog: row.generalDiscountCatalogDto.idGeneralDiscountCatalog
        });
        this.selectedOwnRateDiscount = row
        this.isCreatedOwnRateDiscount = false; // Cambia a modo de edicion
        this.selectedOwnRateDiscountId = row.idOwnRateDiscount; // Asigna el ID del precio académico seleccionado
        row.discountPercentage > 0 ? this.formDiscount.get('importType')?.patchValue('P') : this.formDiscount.get('importType')?.patchValue('I')
        this.formDiscount.get('idGeneralDiscountCatalog')?.disable()
      }
      this.cdr.detectChanges();
    }

  }

  onChangeCatalog(): void {
    // Recargamos las descripciones seleccionadas
    const idCatalogue = this.administrativeFeeCatalogResponse.listAdministrativeFeeCatalogDto.find(catalog => catalog.codeAdministrativeFeeCatalog === this.ownAdministrativeFeeForm.get('codeOwnAdministrativeFeeCatalog')?.value)?.idAdministrativeFeesCatalog || 0;
    this.catalogService.getCatalogById(idCatalogue).subscribe({
      next: (response) => {
        this.selectedAdministrativeFeeCatalogDto = response;

        const catalanIndex = this.selectedAdministrativeFeeCatalogDto?.administrativeFeeCatalogTraductionDto?.findIndex(
          (translation) => translation.languageDto?.code === "ca"
        ) ?? -1;

        const spanishIndex = this.selectedAdministrativeFeeCatalogDto?.administrativeFeeCatalogTraductionDto?.findIndex(
          (translation) => translation.languageDto?.code === "es"
        ) ?? -1;

        const englishIndex = this.selectedAdministrativeFeeCatalogDto?.administrativeFeeCatalogTraductionDto?.findIndex(
          (translation) => translation.languageDto?.code === "en"
        ) ?? -1;

        this.ownAdministrativeFeeForm.patchValue({
          descriptionCast: spanishIndex >= 0 ? this.selectedAdministrativeFeeCatalogDto?.administrativeFeeCatalogTraductionDto?.[spanishIndex]?.description || '' : '',
          descriptionCat: catalanIndex >= 0 ? this.selectedAdministrativeFeeCatalogDto?.administrativeFeeCatalogTraductionDto?.[catalanIndex]?.description || '' : '',
          descriptionIng: englishIndex >= 0 ? this.selectedAdministrativeFeeCatalogDto?.administrativeFeeCatalogTraductionDto?.[englishIndex]?.description || '' : '',
        });
      },
      error: (err) => {
        console.error('Error al obtener el catálogo seleccionado:', err);
      }
    })
  }

  getListOwnAdministrativeFeeById(): void {
    this.ownadministrativefeeService.getOwnAdministrativeFeeById(this.selectedRowId).subscribe({
      next: (response) => {
        this.ownadministrativefee = response;

        const catalanIndex = this.ownadministrativefee?.administrativeFeeCatalogDto?.administrativeFeeCatalogTraductionDto?.findIndex(
          (translation) => translation.languageDto?.code === "ca"
        ) ?? -1;

        const spanishIndex = this.ownadministrativefee?.administrativeFeeCatalogDto?.administrativeFeeCatalogTraductionDto?.findIndex(
          (translation) => translation.languageDto?.code === "es"
        ) ?? -1;

        const englishIndex = this.ownadministrativefee?.administrativeFeeCatalogDto?.administrativeFeeCatalogTraductionDto?.findIndex(
          (translation) => translation.languageDto?.code === "en"
        ) ?? -1;

        // Actualiza el formulario con los datos obtenidos
        this.ownAdministrativeFeeForm.patchValue({
          idOwnAdministrativeFee: this.ownadministrativefee?.idOwnAdministrativeFee || null,
          active: this.ownadministrativefee?.active || '',
          codeOwnAdministrativeFeeCatalog: this.ownadministrativefee?.administrativeFeeCatalogDto?.codeAdministrativeFeeCatalog || undefined,
          descriptionCast: spanishIndex >= 0 ? this.ownadministrativefee?.administrativeFeeCatalogDto?.administrativeFeeCatalogTraductionDto?.[spanishIndex]?.description || '' : '',
          descriptionCat: catalanIndex >= 0 ? this.ownadministrativefee?.administrativeFeeCatalogDto?.administrativeFeeCatalogTraductionDto?.[catalanIndex]?.description || '' : '',
          descriptionIng: englishIndex >= 0 ? this.ownadministrativefee?.administrativeFeeCatalogDto?.administrativeFeeCatalogTraductionDto?.[englishIndex]?.description || '' : '',
        });
      },
      error: (err) => {
        console.error('Error al obtener la tasa administrativa:', err);
      }
    });
  }

  saveOwnAdministrativeFee(): void {
    if (this.ownAdministrativeFeeForm.valid) {

      this.bindFormToObj(); // Enlaza el formulario con el objeto
      if (this.isCreate) {
        this.ownadministrativefeeService.insertOwnAdministrativeFee(this.ownadministrativefee).subscribe({
          next: (response) => {
            console.log('Tasa administrativa creada:', response);
            this.isCreated = true
            this.isCreate = false
            this.isCreatedPrice = false
            this.errorMessage = "S'ha creat correctament"
            this.loadOwnAdministrativeFees(true); // Recarga la lista de tasas administrativas
          },
          error: (err) => {
            this.isCreated = false
            this.isError = true
            this.isErrorPrice = false
            this.errorMessage = err.error.message;
            console.error('Error al crear la tasa administrativa:', err);
          }
        });
      } else {
        this.ownadministrativefeeService.updateOwnAdministrativeFee(this.ownadministrativefee).subscribe({
          next: (response) => {
            console.log('Tasa administrativa actualizada:', response);
            this.isCreated = true
            this.errorMessage = "S'ha editat correctament"
            this.loadOwnAdministrativeFees(true); // Recarga la lista de tasas administrativas
          },
          error: (err) => {
            this.isCreated = false
            this.isError = true
            this.errorMessage = err.error.message;
            console.error('Error al actualizar la tasa administrativa:', err);
          }
        });
      }
    } else {
      this.isCreated = false
      this.isError = true
      this.errorMessage = 'obligatorios';
    }
    console.log('Datos guardados / modificados:', this.ownadministrativefee);
    //this.onCancel(); // Cancela el formulario y reinicia el estado
  }

  saveOwnRateDiscount() {
    if (this.controlDates(this.formDiscount.get('startDate')?.value, this.formDiscount.get('endDate')?.value)) {
      this.isErrorOwnRateDiscount = false
      this.isCreateOwnRateDiscount = false;
      this.isErrorOwnRateDiscount = true
      this.isCreateOwnRateDiscount = false;
      this.errorMessage = 'fechas';
      return
    }
    if (this.selectedOwnRateDiscountId) {
      this.message = this.ownRateDiscountResponse.IdOwnRateDiscountDto.filter(resp => { return resp.idOwnRateDiscount != this.selectedOwnRateDiscountId && resp.discountOrderNumber == this.formDiscount.get('discountOrderNumber')?.value })
    }
    else {
      this.message = this.ownRateDiscountResponse.IdOwnRateDiscountDto.filter(resp => { return resp.discountOrderNumber == this.formDiscount.get('discountOrderNumber')?.value })
    }
    if (this.message.length > 0) {
      return
    }
    this.formDiscount.get('rateType')?.patchValue('D')
    if (this.formDiscount.valid) {
      this.buildOwnRateDiscount()
      if (this.selectedOwnRateDiscountId) {
        this.discountServices.updateOwnRateDiscount(this.selectedOwnRateDiscount).subscribe({
          next: () => {
            this.isCreateOwnRateDiscount = true;
            this.errorMessage = "S'ha editat correctament"
            this.loadOwnRateDiscountByRateType(this.selectedRowId); // Actualiza la lista después de guardar
          }
          , error: (err: { error: { message: string; }; }) => {
            this.isErrorOwnRateDiscount = true
            this.errorMessage = err.error.message
            this.loadOwnRateDiscountByRateType(this.selectedRowId); // Actualiza la lista después de guardar
            console.error('Error al actualizar la tasa académica:', err);
          }
        });
      } else {
        this.discountServices.insertOwnRateDiscount(this.selectedOwnRateDiscount).subscribe({
          next: () => {
            this.isCreateOwnRateDiscount = true;
            this.errorMessage = "S'ha creat correctament"
            this.selectedOwnRateDiscountId = null; // Deselecciona si ya estaba seleccionada
            this.isCreatedOwnRateDiscount = false
            this.formDiscount.reset(); // Limpia los datos del formulario
            this.loadOwnRateDiscountByRateType(this.selectedRowId); // Actualiza la lista después de guardar
          }
          , error: (err: { error: { message: string; }; }) => {
            this.isCreateOwnRateDiscount = false;
            this.isErrorOwnRateDiscount = true
            this.errorMessage = err.error.message
            console.error('Error al crear la tasa académica:', err);
          }
        });
      }
    } else {
      this.isCreateOwnRateDiscount = false;
      this.isErrorOwnRateDiscount = true
      this.errorMessage = 'obligatorios'
    }
  }

  buildOwnRateDiscount() {
    this.selectedOwnRateDiscount.generalDiscountCatalogDto = new GeneralDiscountCatalogDto()
    this.selectedOwnRateDiscount.rateModelDto = new RateModelDto()

    this.selectedOwnRateDiscount.discountOrderNumber = this.formDiscount.get('discountOrderNumber')?.value || undefined
    this.selectedOwnRateDiscount.discountPercentage = this.formDiscount.get('discountPercentage')?.value
    this.selectedOwnRateDiscount.endDate = this.formDiscount.get('endDate')?.value || undefined
    this.selectedOwnRateDiscount.startDate = this.formDiscount.get('startDate')?.value || undefined
    this.selectedOwnRateDiscount.fixedDiscountAmount = this.formDiscount.get('fixedDiscountAmount')?.value
    this.selectedOwnRateDiscount.rateType = "D"
    this.selectedOwnRateDiscount.rateId = this.selectedRowId
    this.selectedOwnRateDiscount.generalDiscountCatalogDto ? this.selectedOwnRateDiscount.generalDiscountCatalogDto.idGeneralDiscountCatalog = this.formDiscount.get('idGeneralDiscountCatalog')?.value : null
    this.selectedOwnRateDiscount.generalDiscountCatalogDto ? this.selectedOwnRateDiscount.generalDiscountCatalogDto.discountCode = this.discountReponse.GeneralDiscountCatalogDto.filter(disc => { return disc.idGeneralDiscountCatalog == this.formDiscount.get('idGeneralDiscountCatalog')?.value })[0].discountCode : null
    this.selectedOwnRateDiscount.rateModelDto ? this.selectedOwnRateDiscount.rateModelDto.idRateModel = this.selectedRateModel.idRateModel : null
    this.selectedOwnRateDiscount.rateModelDto ? this.selectedOwnRateDiscount.rateModelDto.codeRateModel = this.selectedRateModel.codeRateModel : null

    !this.selectedOwnRateDiscountId ? this.selectedOwnRateDiscount.idOwnRateDiscount = undefined : null
  }

  loadDiscounts() {
    this.discountServices.getListGeneralDiscountCatalog(this.discountRequest.pageRequest).subscribe({
      next: response => {
        if (response != null) {
          this.discountReponse.GeneralDiscountCatalogDto = response.listGeneralDiscountCatalog.map((rt: any) => {
            return {
              ...rt,
              generalDiscountCatalogTraductionDto: rt.generalDiscountCatalogTraductionDto.filter((t: any) => t.languageDto.code.includes(this.translateService.currentLang || 'es')),
            };
          });
          response.pageDto !== undefined ? this.discountReponse.pageDto = response.pageDto : null
        }
        console.log(this.discountReponse.GeneralDiscountCatalogDto)
      }, error: (error: any) => {
        console.log('Se ha producido un error', error);
      }
    });
  }

  loadDiscountsRateModel() {
    this.discountServices.getListDiscountRateModelCatalog(this.discountRequest.pageRequest, this.selectedRateModel.idRateModel).subscribe({
      next: response => {
        if (response != null) {
          this.discountRateModelResponse.discountRateModelCatalogDto = response.listDiscountRateModelCatalog.filter((discount: { rateModelDto: { idRateModel: number | null; }; }) => { return discount.rateModelDto.idRateModel == this.filterParams.get('taxModel')?.value })
          this.discountRateModelResponse.discountRateModelCatalogDto = sortByDiscountCode(this.discountRateModelResponse.discountRateModelCatalogDto)
        }
      }, error: (error: any) => {
        console.log('Se ha producido un error', error);
      }
    });
  }

  getDiscountDescription(id?: any): string {
    let descr;
    let discount = this.discountReponse.GeneralDiscountCatalogDto.filter(list => { return list.idGeneralDiscountCatalog == id })
    if (discount.length === 0) {
      return '';
    }
    discount[0].generalDiscountCatalogTraductionDto ? descr = discount[0].generalDiscountCatalogTraductionDto[0].discountDescription : null;
    return descr || ''
  }

  loadOwnRateDiscountByRateType(id: number) {
    this.discountServices.loadOwnRateDiscountByRateType(this.ownRateDiscountRequest.pageRequest, id, "D").subscribe(list => {
      console.log(list)
      this.ownRateDiscountResponse.IdOwnRateDiscountDto = list.listOwnRateDiscount
    })
  }

  private bindFormToObj(): void {
    if (this.ownAdministrativeFeeForm.valid) {
      if (!this.isCreate) {
        this.ownadministrativefee.idOwnAdministrativeFee = this.selectedRowId; // Asigna el ID de la fila seleccionada
      }

      if (!this.ownadministrativefee.rateModelDto) {
        this.ownadministrativefee.rateModelDto = new RateModelDto(); // Asegura que rateModelDto esté inicializado
      }
      this.ownadministrativefee.rateModelDto.idRateModel = this.selectedRateModel.idRateModel; // Asigna el ID del modelo de tasa seleccionado

      if (!this.ownadministrativefee.administrativeFeeCatalogDto) {
        this.ownadministrativefee.administrativeFeeCatalogDto = new AdministrativeFeeCatalogDto(); // Asegura que administrativeFeeCatalogDto esté inicializado
      }
      this.ownadministrativefee.administrativeFeeCatalogDto.idAdministrativeFeesCatalog =
        this.administrativeFeeCatalogResponse.listAdministrativeFeeCatalogDto.find(catalog => catalog.codeAdministrativeFeeCatalog === this.ownAdministrativeFeeForm.get('codeOwnAdministrativeFeeCatalog')?.value)?.idAdministrativeFeesCatalog || undefined; // Asigna el ID del catálogo de tasas administrativas

      this.ownadministrativefee.active = this.ownAdministrativeFeeForm.get('active')?.value || 'S'; // Obtiene el valor del campo activo
    }
  }

  newRegister() {
    this.ownAdministrativeFeeFormPrice.reset()
    this.isCreatePrices = true;
    this.selectedPricesRowId = null;
  }

  savePriceRecord(): void {
    if (this.ownAdministrativeFeeFormPrice.valid) {
      let ownAdministrativeFeeDetail = new OwnAdministrativeFeeDetailDto(); // Inicializa el objeto OwnAdministrativeFeeDetailDto
      this.createPrice = true; // Variable para determinar si se crea un nuevo precio

      if (this.selectedPricesRowId) {
        ownAdministrativeFeeDetail.idOwnAdministrativeFeeDetail = this.selectedPricesRowId;
        this.createPrice = false; // No crea un nuevo precio si ya existe uno
      }

      // Asigna los valores del formulario al objeto DTO
      ownAdministrativeFeeDetail.startDate = this.ownAdministrativeFeeFormPrice.get('startDate')?.value || undefined;
      ownAdministrativeFeeDetail.endDate = this.ownAdministrativeFeeFormPrice.get('endDate')?.value || undefined;
      this.ownAdministrativeFeeFormPrice.get('optionalFeeIndicator')?.value == true ? ownAdministrativeFeeDetail.optionalFeeIndicator = 'S' : ownAdministrativeFeeDetail.optionalFeeIndicator = 'N';
      this.ownAdministrativeFeeFormPrice.get('ageControlIndicator')?.value == true ? ownAdministrativeFeeDetail.ageControlIndicator = 'S' : ownAdministrativeFeeDetail.ageControlIndicator = 'N';
      ownAdministrativeFeeDetail.firstPaymentIndicator = this.ownAdministrativeFeeFormPrice.get('firstPaymentIndicator')?.value || false;
      ownAdministrativeFeeDetail.ageLimit = Number(this.ownAdministrativeFeeFormPrice.get('ageLimit')?.value) || 0;
      ownAdministrativeFeeDetail.price = this.ownAdministrativeFeeFormPrice.get('price')?.value || 0;

      if (!ownAdministrativeFeeDetail.vatPatternDto) {
        ownAdministrativeFeeDetail.vatPatternDto = new VatPatternDto();
      }
      ownAdministrativeFeeDetail.vatPatternDto.idVatPattern = this.ownAdministrativeFeeFormPrice.get('idVatPattern')?.value || undefined;

      if (!ownAdministrativeFeeDetail.ownAdministrativeFeeDto) {
        ownAdministrativeFeeDetail.ownAdministrativeFeeDto = new OwnAdministrativeFeeDto();
      }
      ownAdministrativeFeeDetail.ownAdministrativeFeeDto.idOwnAdministrativeFee = this.selectedRowId;
      console.log('AAAAAAAA', ownAdministrativeFeeDetail)
      if (this.createPrice || this.isClone) {
        // Inserta un nuevo precio

        this.ownadministrativefeeDetailService.insertOwnAdministrativeFeeDetail(ownAdministrativeFeeDetail).subscribe({
          next: (response) => {
            this.isCreated = false
            this.isCreatedPrice = true
            this.errorMessage = "S'ha creat correctament"
            this.isClone = false;
            this.ownAdministrativeFeeFormPrice.reset()
            this.isCreatePrices = false
            this.loadOwnAdministrativeFeePricesById(true); // Actualiza la lista de precios
          },
          error: (err) => {
            this.isError = false
            this.isErrorPrice = true
            this.errorMessage = err.error.message;
            console.error('Error al crear el precio de tasa administrativa:', err);
            this.errorMessage = err.error.message;
          }
        });
      } else {
        // Actualiza un precio existente
        this.ownadministrativefeeDetailService.updateOwnAdministrativeFeeDetail(ownAdministrativeFeeDetail).subscribe({
          next: (response) => {
            this.isCreated = false
            this.isCreatedPrice = true
            this.errorMessage = "S'ha editat correctament"
            console.log('Precio de tasa administrativa actualizado:', response);
            this.loadOwnAdministrativeFeePricesById(true); // Actualiza la lista de precios
          },
          error: (err) => {
            console.error('Error al actualizar el precio de tasa administrativa:', err);
            this.isError = false
            this.isErrorPrice = true
            this.errorMessage = err.error.message;
          }
        });
      }

      console.log('Datos guardados / modificados:', ownAdministrativeFeeDetail);
    } else {
      this.isError = false
      this.isErrorPrice = true
      this.errorMessage = 'obligatorios';
    }
  }

  loadOwnAdministrativeFeePricesById(init: boolean): void {
    if (!init) {
      this.ownAdministrativeFeeDetailRequest.pageRequest.page = this.ownAdministrativeFeeDetailResponse.pageDto.currentPage;
    }

    this.ownadministrativefeeDetailService.getListOwnAdministrativeFeeDetailById(this.ownAdministrativeFeeDetailRequest.pageRequest, this.selectedRowId)
      .subscribe({
        next: response => {
          if (response != null) {
            // Asigna la lista de modelos a la propiedad listModels para mostrarlos en la tabla
            this.ownAdministrativeFeeDetailResponse.listOwnAdministrativeFeeDetailDto = response.listOwnAdministrativeFeeDetail;
            if (!response.pageDto) {
              this.ownAdministrativeFeeDetailResponse.pageDto = response.pageDto;
            }
          }
          console.log(this.ownAdministrativeFeeDetailResponse)
        }, error: error => {
          console.log('Se ha producido un error', error);
          this.ownAdministrativeFeeDetailResponse.listOwnAdministrativeFeeDetailDto = []; // Asigna una lista vacía en caso de error
        }
      });
  }

  clone() {
    this.isClone = true;
    this.isCreatedPrice = true;
    this.selectedPricesRowId = null;
    this.errorMessage = "S'ha clonat correctament"
  }

  controlDates(startDate: any, dateEnd: any): boolean {
    if (!dateEnd) { return false }
    return (new Date(startDate) > new Date(dateEnd)) ? true : false;
  }

    isDiscountValid(discountCode: any): boolean {
      console.log(this.ownRateDiscountResponse.IdOwnRateDiscountDto)
      const discount = this.ownRateDiscountResponse.IdOwnRateDiscountDto.find(disc => disc.generalDiscountCatalogDto?.discountCode === discountCode);
      console.log(discount)
      return discount == undefined;
    }

}
function sortByDiscountCode(array: any[]) {
  return array.sort((a: { generalDiscountCatalogDto: { discountCode: string; }; }, b: { generalDiscountCatalogDto: { discountCode: any; }; }) =>
    a.generalDiscountCatalogDto.discountCode.localeCompare(b.generalDiscountCatalogDto.discountCode)
  );
}